// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2mk1h","title":"ClientInsurance_title__15zaj","itemText":"ClientInsurance_itemText__isIHf"};